import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="25" y="15" rx="5" ry="5" width="150" height="50" />
      <rect x="200" y="15" rx="5" ry="5" width="150" height="50" />
      <rect x="375" y="15" rx="5" ry="5" width="150" height="50" />
    </React.Fragment>
  );
};
